import { render, staticRenderFns } from "./CplusYoutubeMonetizeTerms.vue?vue&type=template&id=7a3c0c5c&scoped=true&"
import script from "./CplusYoutubeMonetizeTerms.vue?vue&type=script&lang=js&"
export * from "./CplusYoutubeMonetizeTerms.vue?vue&type=script&lang=js&"
import style0 from "./CplusYoutubeMonetizeTerms.vue?vue&type=style&index=0&id=7a3c0c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c0c5c",
  null
  
)

export default component.exports